import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { RequireLoginModal } from "./RequireLoginModal";
import { useAuthSessionContext } from "./routing/auth-session-store";

export function Searchbar() {
	const navigate = useNavigate();
	const location = useLocation();
	const { session } = useAuthSessionContext();
	const [showLoginModal, setShowLoginModal] = useState(false);

	const redirectToLogin = () => {
		setShowLoginModal(false);
		navigate("/login", {
			state: {
				redirectTo: "/solicitud-servicio-wizard",
				redirectState: { modal: true, backgroundLocation: location },
			},
		});
	};

	return (
		<>
			<button
				type='button'
				aria-label='Buscar un servicio'
				className='mx-auto flex h-11 w-full max-w-88 items-center justify-center overflow-hidden rounded-3xl bg-primary px-4 text-center cursor-pointer sm:max-w-96 sm:px-6'
				onClick={() => {
					if (!session?.user?.id) {
						setShowLoginModal(true);
						return;
					}

					navigate("/solicitud-servicio-wizard", {
						state: { modal: true, backgroundLocation: location },
					});
				}}
			>
				<span className='text-base font-normal leading-6 text-white transition-transform sm:text-base'>
					¿Buscas un Servicio?
				</span>
			</button>
			<RequireLoginModal
				isOpen={showLoginModal}
				onClose={() => setShowLoginModal(false)}
				onConfirm={redirectToLogin}
			/>
		</>
	);
}
